import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { theme } from './theme/theme';

// Importação dos Componentes
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      
      <style>
        {`
          /* --- NOVA FONTE: Montserrat --- */
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');
          
          body { 
            font-family: 'Montserrat', sans-serif; 
          }
          
          code { 
            font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace; 
          }
          
          html { 
            scroll-behavior: smooth; 
          }
        `}
      </style>

      <Header />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <TestimonialsSection />
      <Footer />
      
      <FloatingWhatsApp />
    </ThemeProvider>
  );
}

export default App;